import { Select, Tag, Tooltip } from "antd";
import { RATING_OPTIONS, MAX_RATING } from "./RatingDisplay";

interface RatingSelectProps {
  value?: number;
  onChange?: (value: number | undefined) => void;
}

export function RatingSelect({ value, onChange }: RatingSelectProps) {
  return (
    <Select
      allowClear
      placeholder="Wybierz ocenę"
      style={{ width: "100%", minWidth: 220 }}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? undefined)}
      options={RATING_OPTIONS.map((opt) => ({
        value: opt.value,
        label: (
          <Tooltip
            title={`${opt.value} na ${MAX_RATING} — ${opt.description}`}
            placement="right"
          >
            <span
              style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
            >
              <Tag
                style={{
                  margin: 0,
                  fontWeight: 500,
                  minWidth: 20,
                  textAlign: "center",
                  backgroundColor: opt.color,
                  color: "#fff",
                  border: "none",
                }}
              >
                {opt.value}
              </Tag>
              <span style={{ fontWeight: 500 }}>{opt.label}</span>
            </span>
          </Tooltip>
        ),
      }))}
    />
  );
}

export default RatingSelect;
